
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-gateway/cashfree",
      function () {
        return require("private-next-pages/payment-gateway/cashfree.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-gateway/cashfree"])
      });
    }
  